import { render, staticRenderFns } from "./ArchiveComponent.vue?vue&type=template&id=318d331f"
import script from "./ArchiveComponent.vue?vue&type=script&lang=js"
export * from "./ArchiveComponent.vue?vue&type=script&lang=js"
import style0 from "./ArchiveComponent.vue?vue&type=style&index=0&id=318d331f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports